import gsap from 'gsap';

export default class Popin {
    constructor() {
        this.closePopin();
    }

    closePopin() {
        const popin = document.querySelector('.popin'),
              btnClose = document.querySelector('.close-popin');

        if (popin) {
            btnClose.addEventListener('click', function(){
                gsap.to(
                    popin,
                    {
                        yPercent: -100,
                        ease: "power4.out",
                        duration: .85,
                        onComplete: () => {
                            popin.style.display = 'none';
                        }
                    }
                );
            });
        }
    }
}